<template>
  <div :class="$style.wrapper">
    <Score v-if="started" />
    <stripes />
    <transition name="button-fade">
      <Start v-if="!started" @next="started = true" />
    </transition>
    <transition name="fade">
      <Trainer v-if="started" @success="finished = true" />
    </transition>
    <transition name="fade">
      <Result v-if="finished" />
    </transition>
  </div>
</template>
<script>
import Start from './components/Start'
import Trainer from './components/Trainer/Trainer'
import Score from '@/components/@layout/Score/Score'
import Result from '@/components/Result'

export default {
  name: 'Home',
  components: {
    Start, Trainer, Score, Result,
  },
  created() {
    this.$store.commit('RESET_RESULT')
  },
  data() {
    return {
      started: false,
      finished: false,
    }
  },
}
</script>
<style lang="scss" src="./Home.scss" module></style>
